import lity from 'lity';

export default class Lity {
  constructor () {
    this.listenToScrollEvent();
    this.init();
  }

  init() {
    $('[data-aptim-lity]').on('click', lity);
  }

  listenToScrollEvent () {
    $("body").on("wheel", function (e) {
      if ($(e.target).is(".lity-wrap")) {
        e.preventDefault()
      }
    })
  }
}
